export const AsideKindEnum = {
	DEFAULT: "default",
	CLEAR: "clear",
};
